import { Accept } from "react-dropzone";

export type UploadableModality = "IMAGE" | "VIDEO" | "AUDIO" | "THREE_D";

const ACCEPTED_IMAGE_TYPES: Accept = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
  "image/gif": [".gif"],
};

const ACCEPTED_VIDEO_TYPES: Accept = {
  "video/mp4": [".mp4"],
  "video/quicktime": [".mov"],
  "video/x-msvideo": [".avi"],
  "video/webm": [".webm"],
};

const ACCEPTED_3D_TYPES: Accept = {
  "model/gltf-binary": [".glb"],
  "model/gltf+json": [".gltf"],
};

const ACCEPTED_AUDIO_TYPES: Accept = {
  "audio/mpeg": [".mp3"],
  "audio/wav": [".wav"],
  "audio/aac": [".aac"],
};

const ACCEPTED_AI_MODEL_TYPES: Accept = {
  "application/octet-stream": [".safetensors"],
};

export const ACCEPTED_FILE_TYPES_BY_MODALITY = new Map<
  UploadableModality,
  Accept
>([
  ["IMAGE", ACCEPTED_IMAGE_TYPES],
  ["VIDEO", ACCEPTED_VIDEO_TYPES],
  ["THREE_D", ACCEPTED_3D_TYPES],
  ["AUDIO", ACCEPTED_AUDIO_TYPES],
]);

export const ACCEPTED_DRIVE_TYPES: Accept = {
  ...ACCEPTED_IMAGE_TYPES,
  ...ACCEPTED_VIDEO_TYPES,
  ...ACCEPTED_3D_TYPES,
  ...ACCEPTED_AUDIO_TYPES,
  ...ACCEPTED_AI_MODEL_TYPES,
  "image/vnd.adobe.photoshop": [".psd"],
};
